import { createContext } from 'react'

import { ConsoleLayoutContextValue } from './interface'

export const ConsoleLayoutContext = createContext<ConsoleLayoutContextValue>(
  {} as any
)
